import QRCode from 'qrcode';
import * as api from 'auth/resources/two-factor.api';
import { getApplicationName } from 'selectors';
import DefaultDialogController from 'utils/notifications/default-dialog-controller';
import { confirmTwoFactorCode } from 'auth/resources/two-factor.api';
import template from './setup-two-factor-dialog.html';

const mapStateToThis = (state) => {
  const applicationName = getApplicationName(state);

  return {
    applicationName,
  };
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux')
class SetupTwoFactorDialogController extends DefaultDialogController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, null)(this);
  }

  async $onInit() {
    const response = await api.fetchTwoFactorSetup();
    this.secret = response.secret;
    this.imageQR = await QRCode.toDataURL(this.generateURI());
  }

  $onDestroy() {
    this.unsubscribe();
  }

  generateURI() {
    const username = encodeURIComponent(this.resolve.credentials.username);
    const issuer = encodeURIComponent(this.applicationName);
    return `otpauth://totp/${issuer}:${username}?secret=${this.secret}&issuer=${issuer}`;
  }

  async confirm() {
    try {
      const params = {
        resourceOwnerCredentials: this.resolve.credentials,
        secret: this.secret,
        code: this.code,
        remember: true,
      };
      const tokens = await api.confirmTwoFactorCode(params);
      this.close({ $value: tokens });
    } catch (error) {
      console.error(error);
      this.showErrorCode = true;
    }
  }
}
export default class SetupTwoFactorDialogComponent {
  constructor() {
    this.template = template;
    this.controller = SetupTwoFactorDialogController;
    this.bindings = {
      resolve: '<',
      close: '&',
      dismiss: '&',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/auth/components/two-factor/components/setup-two-factor-dialog/setup-two-factor-dialog-component.js